import { atom } from 'jotai';

import type { IDynamicBannerState } from './DynamicBanner.types';

export const dynamicBannerAtom = atom<IDynamicBannerState | null>(null);
